export default "__VITE_ASSET__So8$cfbo__"